import React from 'react';
import type ServicedeskKnowledgeHubBrowseAllArticlesType from '@atlassian/jira-spa-apps-servicedesk-knowledge-hub-browse-all-articles/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskKnowledgeHubBrowseAllArticles = lazyForPaint<
	typeof ServicedeskKnowledgeHubBrowseAllArticlesType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-knowledge-hub-browse-all-articles", jiraSpaEntry: "async-servicedesk-knowledge-hub-browse-all-articles" */ '@atlassian/jira-spa-apps-servicedesk-knowledge-hub-browse-all-articles'
		),
	),
);

const AsyncServicedeskKnowledgeHubBrowseAllArticles = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskKnowledgeHubBrowseAllArticles}
		pageId="spa-apps/servicedesk/knowledge-hub/browse-all-articles"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskKnowledgeHubBrowseAllArticles;
